export const REALTORS_ON_PAGE = 10;
export const PAGINATION_WIDTH = 5;
